<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        :max-date="data.form.dataAtual"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="agendamentoExame"
                        label="Grupo"
                        show-default-option
                        text-field="nome"
                        v-model="model.exameId"
                        value-field="id"
                        @change="setListagem()"
                    />
                </rkm-col>

                <rkm-col cols="3">

                    <rkm-form-checkbox
                        v-model="model.impressaoPendente"
                        :label="false"
                        @change="setListagem()"
                    >
                        Apenas pendente de impressão
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="unidadeSolicitante"
                        label="Unidade solicitante"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                        @change="setListagem()"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        valueField="id"
                        show-default-option
                        @change="setListagem()"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">
                <rkm-col cols="auto">
                    <rkm-button
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>

                    <rkm-button
                        v-if="itemsNotSave && itemsNotSave.length > 0"
                        @click="confirmPrint()"
                        color="info"
                    >
                        Imprimir listagem
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="itemsNotSave"
            class="mt-2"
            :items="itemsNotSave || items"
            :fields="fields"
            hide-filters
            sort-by="exameGrupoNome"
        >

            <template v-slot:cell(pacienteNome)="{ item }">
                {{ item.pacienteNome }}

                <template v-if="item.pacienteNomeSocial">
                    <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.pacienteNomeSocial }})
                    </template>
                </template>
            </template>

            <template v-slot:cell(siglaExame)="{ item }">

                {{ handleSigla(item) }}
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    small
                    title="Imprimir"
                    @click="confirmPrint(item)"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, object, formats, data, stringCase, printExameLaboratorial } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: "agendamentoNumero",
                    label: "Agendamento",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "pacienteProntuario",
                    label: "Prontuário",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "pacienteNome",
                    label: "Nome",
                    sortable: true
                },
                {
                    key: "pacienteNascimento",
                    label: "Data de nascimento",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "pacienteSexoDescricao",
                    label: "Sexo",
                    sortable: true
                },
                {
                    key: "pacienteIdade",
                    label: "Idade",
                    sortable: true
                },
                {
                    key: "data",
                    label: "Data da coleta",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "exameGrupoNome",
                    label: "Grupo",
                    sortable: true
                },
                {
                    key: "observacao",
                    label: "Observação",
                    sortable: true
                },
                {
                    key: "siglaExame",
                    label: "Sigla",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]

            return fields
        },
        autocompletesRequestParams() {

            return {
                exame: {
                    queryString: {
                        tipo_id: this.tipoExameId,
                        exame_grupo: true,
                    }
                }
            }
        },
        fieldsAutoComplete() {

            return {
                autocompletes: {
                    exame: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true }
                    ],
                }
            }
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                coletaUnidade: { required: true },
                coletaInfraestrutura: { required: true },
            }
        },
        infraestruturas() {

            this.setInfraestrutura()

            if (this.model.unidadeId && this.unidadeSolicitante.length > 0) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.id == this.model.unidadeId).infraestruturas

                this.handleInfraestrutura(infraestruturaPrincipal)

                return infraestruturaPrincipal
            }

            return []
        },

    },
    created() {

        this.repositories = {
            mapaProducao: this.getConectaSusRepository('exameLaboratorial.mapaProducao'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                impressaoPendente: null,
                exame: null,
                exameId: null,
                exameNome: null,
                unidadeId: null,
                infraestruturaId: null,
                agendamentoId: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            itemsNotSave: null,
            saveAgendamento: {
                agendamentos: [],
            },
            unidadeSolicitante: [],
            agendamentoExame: [],
            items: [],
            agendamentosSiglas: [],
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            unwatchers: {
                modelPeriodoEnd: null,
                modelPeriodoStart: null,
            },
        }
    },
    mixins: [repository, error, object, formats, data, printExameLaboratorial, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo = this.data.form.periodo

            this.$nextTick()
                .then(() => this.loadFields())
                .then(() => this.addWatchers())
        },
        prepareData(item) {

             this.saveAgendamento.agendamentos = []

                if (item) {

                    this.saveAgendamento.agendamentos.push(item)

                } else {

                    this.saveAgendamento.agendamentos = this.clone(this.itemsNotSave)
                }

                const notSave = this.saveAgendamento

                return this.camelObjectKeysToSnakeRecursive(notSave)

        },
        search() {

            this.setLoading()

            this.repositories.mapaProducao.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                    this.agendamentosSiglas = data.model.agendamentosSiglas
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams(item) {

            const params = this.clone(this.model)

            if (item) {

                params.agendamentoId = item.agendamentoId
                params.exameId = item.exameGrupoId
            }

            if (this.model.exameId) {

                params.pertenceGrupo = this.agendamentoExame.find(u => u.id == this.model.exameId).pertenceGrupo
                params.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (this.model.unidadeId) {

               this.model.unidadeNome = this.unidadeSolicitante.find(u => u.id == this.model.unidadeId).nomeFantasia
            }

            if (this.model.infraestruturaId) {

               this.model.infraestruturaNome = this.infraestruturas.find(u => u.id == this.model.infraestruturaId).nome
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exame = null
            this.model.exameId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.itemsNotSave = null

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            const infraestrutura =infraestruturaPrincipal
                .find(infraestrutura => infraestrutura.id == this.data.form.infraestruturaId)

                if (infraestrutura) {

                    this.model.unidadeId = this.data.form.unidadeId
                    this.model.infraestruturaId = this.data.form.infraestruturaId
                } else if (infraestruturaPrincipal.find(u => u.principal)) {

                    this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal).id
                } else {

                    this.model.infraestruturaId = null
                }
        },
        setInfraestrutura() {

            this.model.infraestruturaId = null
        },
        handleListPrint(item) {

            this.setLoading()

            this.repositories.impressao.mapaProducao(this.getSearchParams(item))
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading(this.$nextTick(() => this.save(item))))
        },
        confirmPrint(item) {

            if (this.model.impressaoPendente) {

                const confirm = async () => {

                    this.handleListPrint(item)
                }

                const msg = `A busca foi realizada apenas para impressões pendentes. Caso imprima o(s) registro(s),
                    a listagem será atualizada, permanecendo apenas o(s) registro(s) não impresso(s).  Deseja continuar?`

                    this.showConfirmation(msg, confirm)

                return false

            } else {

                this.handleListPrint(item)
            }
        },
        save(item) {

            this.setLoading()

                this.repositories.mapaProducao.store(this.prepareData(item))
                .then(() => {})
                    .catch(this.handleError)
                    .finally(() => {

                        if (this.model.impressaoPendente) {

                            this.unsetLoading(this.$nextTick(() => this.search()))
                        } else {
                             this.unsetLoading()
                        }
                    })
        },
        loadFields() {

            this.setLoading()

            this.repositories.mapaProducao.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadUnidadeSolicitante(data.unidades)
                    this.agendamentoExame = data.grupos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(unidades) {

            this.unidadeSolicitante = unidades

            const unidade = unidades.find(u => u.id == this.data.form.unidadeId);

            if (unidade) {

                const infraestrutura = unidade.infraestruturas
                    .find(infraestrutura => infraestrutura.id == this.data.form.infraestruturaId)

                    if (infraestrutura) {
                        this.model.unidadeId = this.data.form.unidadeId
                        this.model.infraestruturaId = this.data.form.infraestruturaId
                    }
            }
        },
        setListagem() {

            this.itemsNotSave = null
        },
        handleSigla(item) {

            return this.agendamentosSiglas.find(sigla => sigla.agendamentoId == item.agendamentoId).siglaExame
        },
        addWatchers() {

            this.addModelPeridoStartWatcher()
            this.addModelPeridoEndWatcher()
        },
        addModelPeridoStartWatcher() {

            this.unwatchers.modelPeriodoStart = this.$watch('model.periodo.start', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
        addModelPeridoEndWatcher() {

            this.unwatchers.modelPeriodoEnd = this.$watch('model.periodo.end', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}
</style>